import {
  Box,
  Button,
  styled,
  TextField
} from "@mui/material";
import React, {useEffect, useState} from "react";
import ThemedText from "../../text";
import {LOGO_2} from "../../../constants/images";
import Label from "../../../resources/label";
import {NewOperatorRequest, SelectValue, SezioneAvis} from "../../../types";
import {createOperator, getAllSezioneAvis} from "../../../features/admin";
import theme, {FONTS} from "../../../constants/theme";
import {scale} from "../../../utils";
import ThemedSelect from "../../input/select";
import {useNavigate} from "react-router-dom";

interface Props {
  style?: React.CSSProperties;
}

const LogoImage = styled('img')({
  height: scale(113),
  width: scale(280.42),
  marginBottom: scale(50),
});

const InputWrapper = styled('div')({
  width: scale(400),
  height: scale(35),
  display: 'flex',
  rowGap: 2,
  flexDirection: 'column',
  flexBasis: '50%',
  alignItems: 'stretch',
  justifyContent: 'flex-start',
  boxSizing: 'border-box',
  marginBottom: scale(2),
});

const ThemedButton = styled(Button)({
  borderRadius: scale(30),
  width: scale(132),
  height: scale(52),
  marginTop: scale(40),
  marginBottom: scale(40),
});

const NewOperatorForm = ({style}: Props) => {
  const navigate = useNavigate();
  const [username, setUsername] = useState('');
  const [userError, setUserError] = useState(false);
  const [userErrorLabel, setUserErrorLabel] = useState('');
  const [sezioneAvis, setSezioneAvis] = useState('-');
  const [listaSezioneAvis, setListaSezioneAvis] = useState<Array<SezioneAvis>>(new Array<SezioneAvis>());


  useEffect(() => {
    getAllSezioneAvis().then(sezioneAvisResponse => {
      if (Array.isArray(sezioneAvisResponse)) {
        setListaSezioneAvis(sezioneAvisResponse)
      }
    })
  }, [])

  const handleCreateNewOperator = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const newOperator: NewOperatorRequest = {username: username, sezioneAvis: sezioneAvis};
    createOperator(newOperator).catch((err: Error) => {
      console.log(err);
      setUserError(true);
      setUserErrorLabel('Verificare i dati inseriti');
    }).finally(() => {
      console.log('operatore creato')
      setUserError(false);
      setUserErrorLabel('');
      navigate('/')
    })

  };

  const slotProps = {
    input: {
      sx: {
        fontFamily: FONTS.MONTSERRAT,
        fontWeight: 500,
        fontSize: scale(24),
        color: theme.palette.ceramic.contrastText,
        height: scale(40),
        boxSizing: 'border-box',
        backgroundColor: 'transparent',
        borderRadius: 0,
        '& > input': {
          height: scale(40),
          paddingTop: scale(7),
          paddingLeft: scale(8),
          paddingBottom: scale(6),
          boxSizing: 'border-box',
        }
      },
    },
  }
  const inputRootStyle = {
    borderRadius: 0,
    '& .MuiInput-underline:before': {
      borderBottom: '1px solid',
      borderColor: theme.palette.primary.main,
    },
    '& .MuiInput-underline:hover:not(.Mui-disabled):before': {
      borderBottom: '1px solid',
      borderColor: theme.palette.primary.main,
    },
  }

  const isButtonDisabled = (): boolean => {
    return (!username.trim() || sezioneAvis === '-')
  }

  return (
    <Box
      component="form"
      noValidate={true}
      autoComplete="true"
      onSubmit={(e) => handleCreateNewOperator(e)}
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        height: '100%',
        ...style
      }}
    >
      <LogoImage alt={'logo_header'} src={LOGO_2}/>
      <ThemedText
        fontSize={scale(24)}
        align={'center'}
        fontWeight={600}
        lineHeight={scale(66)}
        letterSpacing={'0px'}
        text={Label.ADMIN_CREATE_OPERATOR}
        color={'primary'}
      />
      <InputWrapper>
        <TextField
          placeholder="Inserisci username"
          variant="standard"
          color={'primary'}
          size={'small'}
          slotProps={slotProps}
          onChange={(event) => {
            if (!username.trim()) {
              setUsername(event.target.value);
            }
          }}
          onBlur={(event) => {
            setUsername(event.target.value);
          }}
          error={userError}
          helperText={userErrorLabel}
          sx={inputRootStyle}
        />
      </InputWrapper>
      <ThemedSelect
        variant={'standard'}
        label={'Sezione Avis'}
        id={'sezione-avis'}
        values={listaSezioneAvis.map(el => {
          return {value: el.id, name: el.name}
        })}
        setSelectedValue={(value: SelectValue) => setSezioneAvis(value.name)}
        sxProp={{width:'100%'}}
      />
      <ThemedButton type={'submit'} variant="contained" disabled={isButtonDisabled()}>
        <ThemedText text={'crea'} fontWeight={600} fontSize={scale(18)}/>
      </ThemedButton>
    </Box>
  )
}

export default NewOperatorForm
